import { string, object } from 'yup';

export const validationSchema = object().shape({
  name: string().required('Home group name is required'),
});
